import { privateApi, publicApi } from "../api/axios";

// Requête pour envoie un email lors d'un mot de passe oublie
export const login = async (email: string, password: string) => {
    try {
        const response = await publicApi.post("api/login", { email, password });
        return response;
    } catch (error) {
        throw error;
    }
}

export const requestPasswordReset = async (email: string) => {
    try {
        const response = await publicApi.post("api/login/request-reset-password", { email });
        return response;
    } catch (error) {
        throw error;
    }
}

export const resetPassword = async (token: string, password: string) => {
    try {
        const response = await publicApi.post("api/login/reset-password", { token, password });
        return response;
    } catch (error) {
        throw error;
    }
}

export const verify2FA = async (email: string, code: string, remember: boolean) => {
    try {
        const response = await publicApi.post("api/login/2fa", { email, code, remember });
        return response;
    } catch (error) {
        throw error;
    }
}

export const logout = async () => {
    try {
        const response = await privateApi.post("api/login/logout");
        return response;
    } catch (error) {
        throw error;
    }
}

export const loginWithOffice = async (idToken: string, accessToken: string) => {
    try {
        const response = await publicApi.post(`api/login/office?token=${idToken}&accessToken=${accessToken}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const verifyToken = async (accessToken: string) => {
    try{
        const response = await publicApi.post(`api/login/is-token-valid`, {token: accessToken})
        return response;
    } catch (error) {
        throw error
    }
}